import { render } from "./CTAButton.vue?vue&type=template&id=4cfcdd76&scoped=true"
import script from "./CTAButton.vue?vue&type=script&lang=ts"
export * from "./CTAButton.vue?vue&type=script&lang=ts"

import "./CTAButton.vue?vue&type=style&index=0&id=4cfcdd76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4cfcdd76"

export default script